import request from '@/helpers/customAxios'
import { Ref, ref } from '@vue/composition-api'

export interface DownloadTableFile {
    id: string
    status: 'pause' | 'pre-downloading' | 'downloading' | 'finished' | 'merging' | 'error'
    name: string
    size: string
    type: string
    progress: number
    errorChunks: number[]
    totalChunks: number
    totalSize: number
    chunks: ChunkItem[]
    speed: string
    remainTime: string
    httpRes: any
}
export interface ChunkItem {
    id: string
    index: number
    totalChunks: number
    status: 'pause' | 'pre-downloading' | 'downloading' | 'finished'
    errorArray: TaskErrorItem[]
    loaded: number
    prevRequst?: ProgressReqItem
    speed: number
}
export interface ProgressReqItem {
    time: number
    loaded: number
}
export interface TaskErrorItem {
    timeStamp: number
}
export interface UploadTableFile {
    id: string // md5的id,给后台
    realId: string // 前端使用的id增加文件名字，避免重名问题
    status: 'pause' | 'pre-uploading' | 'uploading' | 'finished' | 'error'
    name: string
    size: string
    fileType: string
    progress: number
    currentChunkIndex: number
    chunkSize: number
    chunkSizeArray: number[]
    errorChunks: number[]
    totalChunks: number
    totalSize: number
    dirId: string
    target: string
    chunks: ChunkItem[]
    speed: string
    remainTime: string
    httpRes: any
    shouldUpload: boolean
    path: string
    chunkSerialNums?: string[] //
    clientIdentify?: string // 任务标识
    completeTime?: string
    createTime?: string
    updateTime?: string
    uploadChunkSize?: number
    userId: string
    uploadTaskId?: string // 任务标识
    type?: number // 文件上传或下载
}

export interface GetTaskListParams {
    types: string
    status: string
    search?: string
    startTime?: string
    endTime?: string
}
export interface TableListRes {
    code: number
    data: TableItem[]
    desc: string
}
export interface TableItem {
    chunkSerialNums: string[]
    chunkSize: number
    clientIdentify: string
    completeTime: string
    createTime: string
    dirId: string
    id: string
    name: string
    path: string
    status: number
    totalSize: number
    type: number
    updateTime: string
    uploadChunkSize: number
    userId: string
    size?: string
}
export async function getTaskList(params: GetTaskListParams): Promise<TableListRes> {
    return request.get('/api/getTaskList', { params: params })
}

export interface UnzipComporessListItem {
    createTime: number
    id: string
    name: string
    size: number
    status: number
    target: string
    type: number
}
export async function getTaskListUnzipCompress(): Promise<{
    code: number
    data: UnzipComporessListItem[]
    desc: string
}> {
    return request.get('/api/getTaskListUnzipCompress')
}

export function handlePagination(uploadList: Ref<any[]>) {
    const currentList = ref<any[]>([])
    const currentPageNum = ref<number>(1)
    const pageSize = ref<number>(10)
    const handleCurrentChange = pageNum => {
        const totalLen = uploadList.value.length
        currentPageNum.value = pageNum
        const start = (pageNum - 1) * pageSize.value
        const end = start + pageSize.value
        if(uploadList.value&&uploadList.value.length){
            currentList.value =uploadList.value.slice(start, end)
        } 
    }
    const updateCurrentList = () => {
        const totalLen = uploadList.value.length
        // if ((currentPageNum.value - 1) * pageSize > totalLen) {
        //   const startPos = Math.floor(totalLen / pageSize) * pageSize;
        //   currentList.value = uploadList.value.slice(startPos);
        // } else {
        const start = (currentPageNum.value - 1) * pageSize.value
        const end = start + 10
        if(uploadList.value&&uploadList.value.length){
            currentList.value =uploadList.value.slice(start, end+1)
        } 
        // currentList.value = uploadList.value.slice(start, end + 1)
        // }
    }
    return {
        pageSize,
        currentList,
        currentPageNum,
        handleCurrentChange,
        updateCurrentList,
    }
}
